import { RouteConfig } from "vue-router";
import ShiftComponent from "@/views/shift/shift.vue";
import { Roles } from "@/types/enums.type";

export default [
  {
    path: "/shifts",
    name: "Shifts",
    component: ShiftComponent,
    meta: {
      roles: [Roles.PracticeUser, Roles.OfficeUser],
      nav: true,
      navTitle: "Shift Board",
      navIcon: "fa-calendar-alt" 
    }
  }
] as RouteConfig[];